/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest = {
  ledgerCanisterId: string;
  id: string;
};

/** @internal */
export const GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$inboundSchema:
  z.ZodType<
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$Outbound =
  {
    ledger_canister_id: string;
    id: string;
  };

/** @internal */
export const GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$outboundSchema:
  z.ZodType<
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$Outbound,
    z.ZodTypeDef,
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$ {
  /** @deprecated use `GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$inboundSchema;
  /** @deprecated use `GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$outboundSchema;
  /** @deprecated use `GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$Outbound` instead. */
  export type Outbound =
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$Outbound;
}

export function getAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequestToJSON(
  getAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest:
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest,
): string {
  return JSON.stringify(
    GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$outboundSchema
      .parse(getAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest),
  );
}

export function getAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest' from JSON`,
  );
}
